import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { tap } from 'rxjs';

import { ProductImportImages } from '@products/interfaces/product-import-images';
import { ProductImportTableValidations } from '@products/interfaces/product-import-table-validations';
import { ApiRoutes } from '@shared/constants/api-routes';
import { paramConvert } from '@shared/helpers/service-helpers';
import { PageResponse } from '@shared/interfaces/page-response.interface';

import { ProductImportImagesPageRequest } from '../store/product-import.slice';

@Injectable({
  providedIn: 'root',
})
export class ProductImportService {
  constructor(private readonly httpClient: HttpClient) {}

  public getProductImportImages(filter: ProductImportImagesPageRequest) {
    const params = paramConvert(filter);
    return this.httpClient
      .get<PageResponse<ProductImportImages>>(
        `${ApiRoutes.baseApi}/import/images`,
        {
          params: params,
        }
      )
      .pipe(tap((res) => res.content as Array<ProductImportImages>));
  }

  public postProductImportImages(formData: FormData) {
    return this.httpClient.post(`${ApiRoutes.baseApi}/import/images`, formData);
  }

  public deleteProductImportImage(fileName: string) {
    return this.httpClient.delete(
      `${ApiRoutes.baseApi}/import/images/${fileName}`
    );
  }

  public postProductImportTables(formData: FormData) {
    return this.httpClient.post(`${ApiRoutes.baseApi}/import/excels`, formData);
  }

  public getProductImportTableValidationList(fileName: string) {
    return this.httpClient.get<ProductImportTableValidations[]>(
      `${ApiRoutes.baseApi}/import/excels/${fileName}/validate`
    );
  }
}
